module.exports = __webpack_public_path__ + "img/arrow-down-light.bbfd2322.svg";